interface IBackendMessage {
  code?: string;
  message?: string;
}

export function normalizeMutationResponse<T>(response: T): T {
  if (!response || typeof response !== "object" || !("data" in response))
    return response;

  const body = response.data;

  if (
    !body ||
    typeof body !== "object" ||
    !("data" in body) ||
    !("messages" in body) ||
    !Array.isArray(body.messages)
  )
    return response;

  return {
    ...response,
    data: body.data,
    messages: body.messages as IBackendMessage[],
  } as T;
}
